export const API_KEY = process.env.REACT_APP_GOAPP_API_KEY;
export const API_URL = process.env.REACT_APP_GOAPP_API_URL;
export const API_V2_URL = process.env.REACT_APP_GOAPP_API_V2_URL;
export const API_V2_PREDEFINED_TOKEN = process.env.REACT_APP_GOAPP_V2_PREDEFINED_TOKEN;
export const AUTH_API_URL = process.env.REACT_APP_GOAPP_API_URL + "/auth";
export const ACCOUNT_AUTHORIZE_URL = process.env.REACT_APP_ACCOUNT_URL + "/authorize";
export const ACCOUNT_LOGOUT_URL = process.env.REACT_APP_ACCOUNT_URL + "/logout";
export const MANAGE_ACCOUNT_URL = process.env.REACT_APP_MANAGE_ACCOUNT_URL;